import React, { Component } from 'react'
import PropTypes from 'prop-types'

/**
 * Keyboard-based barcode scanning modal
 * Shows waiting message for hardware barcode scanner input
 */
class KeyboardScanModal extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
  }

  render() {
    const { onCancel } = this.props

    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
        tabIndex={-1}
        ref={(el) => el && el.focus()}
      >
        <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
          {/* Barcode Icon */}
          <div className="text-center mb-6">
            <svg
              className="w-24 h-24 mx-auto text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
              />
            </svg>
          </div>

          {/* Instructions */}
          <h3 className="text-xl font-bold text-center text-gray-800 mb-2">
            Waiting for barcode scan
          </h3>
          <p className="text-center text-gray-600 mb-6">
            Please scan the boarding pass barcode using your barcode scanner
          </p>

          {/* Scanning Animation */}
          <div className="flex justify-center mb-6">
            <div className="animate-pulse flex space-x-2">
              <div className="w-2 h-8 bg-blue-600 rounded"></div>
              <div className="w-2 h-10 bg-blue-600 rounded"></div>
              <div className="w-2 h-6 bg-blue-600 rounded"></div>
              <div className="w-2 h-12 bg-blue-600 rounded"></div>
              <div className="w-2 h-8 bg-blue-600 rounded"></div>
            </div>
          </div>

          {/* Cancel Button */}
          <button
            type="button"
            onClick={onCancel}
            tabIndex={-1}
            onKeyDown={(e) => e.preventDefault()}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white font-bold py-3 px-6 rounded-lg transition-colors min-h-[48px]"
          >
            Cancel
          </button>
        </div>
      </div>
    )
  }
}

export default KeyboardScanModal
